export default __webpack_public_path__ + "static/media/dos.f819342a.svg";